export default __webpack_public_path__ + "1b3fec1e59e846ee1dd3e1ed4faa6566.svg";